/**
 * Usage:
 * import { showElement } from '@local_modules/generic/dom/show-element.js'
 *
 * @param {String} elementId
 * @returns {Element|null} DOM Element or null
 */
export function showElement (elementId) {
  const element = document.getElementById(elementId)
  if (!element) return null

  element.classList.remove('is-hidden')
  return element
}
